import { apiPost } from './http-client';
import type { LoginContextOption, LoginSurface } from './auth-contexts';

export type ClientLoginBody = {
  login?: string | null;
  phone?: string | null;
  email?: string | null;
  password?: string;
  /** Если не передан — глобальный режим: токен для основного членства, need_org_select если несколько. */
  org_slug?: string | null;
  /** Точка входа клиентского раздела. */
  surface?: LoginSurface;
  /** Студии приложения (для конфигурации с несколькими студиями). */
  org_slugs?: string[];
  /** Токен Yandex SmartCaptcha (когда captcha_enabled=true). */
  captcha_token?: string;
};

export type ClientLoginResponse = {
  access_token: string | null;
  refresh_token?: string | null;
  token_type: string;
  need_register: boolean;
  message: string | null;
  organization_id: number | null;
  organization_name: string | null;
  /** true если у пользователя несколько клиентских членств — нужно выбрать организацию. */
  need_org_select?: boolean;
  /** slug организации, для которой выдан токен — используется как ключ сессии. */
  organization_slug?: string | null;
  /** Сервер может потребовать выбрать студию (приложение с несколькими студиями). */
  status?: 'context_required';
  contexts?: LoginContextOption[];
  selection_token?: string;
  expires_in?: number;
};

/** POST /api/v1/public/client-login */
export function postClientLogin(body: ClientLoginBody): Promise<ClientLoginResponse> {
  return apiPost<ClientLoginResponse>('/api/v1/public/client-login', body);
}
